import { useState } from 'react';
import { Dialog, TextInputField, Button, toaster, SelectMenu, Checkbox } from 'evergreen-ui';
import sectionServices from '../services/sectionServices';

const EditSectionDialog = ({ isShown, sections, onSectionUpdated, onClose }) => {
    const [selectedSection, setSelectedSection] = useState(null);
    const [newName, setNewName] = useState('');
    const [isVisibleToEducators, setIsVisibleToEducators] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
        if (!selectedSection || !newName.trim()) {
            toaster.warning('Seleziona una sezione e inserisci un nuovo nome.');
            return;
        }

        try {
            setIsSubmitting(true);
            const updatedSection = await sectionServices.updateSection(selectedSection.id, { name: newName, is_visible_to_educators: isVisibleToEducators });
            toaster.success('Sezione aggiornata con successo!');
            onSectionUpdated(updatedSection); 
            onClose();
        } catch (error) {
            console.error('Errore durante l\'aggiornamento della sezione:', error);
            toaster.danger('Errore durante l\'aggiornamento della sezione.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const resetState = () => {
        setSelectedSection(null);
        setNewName('');
        setIsVisibleToEducators(false);
    };

    return (
        <Dialog
            isShown={isShown}
            title="Modifica cartella"
            onCloseComplete={() => {
                resetState();
                onClose();
            }}
            confirmLabel="Salva modifiche"
            cancelLabel='Annulla modifiche'
            onConfirm={handleSubmit}
            isConfirmLoading={isSubmitting}
        >
            <SelectMenu
                title="Seleziona cartella"
                options={sections.map((section) => ({ label: section.name, value: section.id }))}
                selected={selectedSection?.id}
                onSelect={(item) => {
                    const selected = sections.find((section) => section.id === item.value);
                    setSelectedSection(selected);
                    setNewName(selected.name);
                    setIsVisibleToEducators(selected.is_visible_to_educators);
                }}
            >
                <Button>{selectedSection ? selectedSection.name : 'Seleziona cartella da modificare'}</Button>
            </SelectMenu>

            {selectedSection && (
                <>
                    <TextInputField
                        marginTop={16}
                        label="Nuovo nome della cartella"
                        value={newName}
                        onChange={(e) => setNewName(e.target.value)}
                    />
                    <Checkbox
                        label="Visibile agli educatori"
                        checked={isVisibleToEducators}
                        onChange={(e) => setIsVisibleToEducators(e.target.checked)}
                    />
                </>
            )}
        </Dialog>
    );
};

export default EditSectionDialog;